import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js'
import contentTemplate from 'properties/style/line.ejs';
import { pickerCfg } from 'pickerCfg.js';
import themeService from 'ThemeService.js';
import util from 'util/Util.js';
import constants from 'Constants.js';
import eventBus         from 'EventBus.js';
import TextUtil from 'util/TextUtil.js';

class StyleLineView extends BasePropertyView {

    initialize(opts) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'blur input[type=text], input[type=number]': 'lostFocus',
            'focus input[type=text], input[type=number]': 'getFocus',
            'change input[type=color]': 'updateColorAttributes',
            'change #lineColor': 'updateColorAttributesWithValidation',
            'change #separatorSize': 'updateAttributes',
            'click #btn-up-size, #btn-down-size':'changeSize'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    changeSize(ev){
        $('#separatorSize').trigger('change');
    }

    updateAttributes(ev) {
        ev.preventDefault();
        TextUtil.validatePositiveNumeric(ev);
        let propName = ev.currentTarget.name,
            oldValue = this.model.get(propName),
            propVal = ev.currentTarget.value;
        
        if (parseInt(propVal) <= 0) {
            propVal = 1;
            ev.currentTarget.value = 1;
        }
        super.updateAttributes(ev);

        if (this.model.get('factoryKey') === 'control_vertical_separator') {
            this.model.set('width', propVal, constants.MODEL_SILENT);
            eventBus.trigger(constants.EV_NAV_POSITION_PROPERTY_CHANGED);
        } else if (this.model.get('factoryKey') === 'control_horizontal_separator') {
            this.model.set('height', propVal, constants.MODEL_SILENT);
            eventBus.trigger(constants.EV_NAV_POSITION_PROPERTY_CHANGED);
        }

        if ( this.isThemeProperty(oldValue) ){
            themeService.deattachTheme(this);
        }
    }

    render() {
        super.render();
        let props = this.resolveThemeColors(this.model, ['lineColor', 'width', 'height']);
        this.$el.html(this.template(props));
        //.$('input[type=color]', this.$el).spectrum(pickerCfg);
        
        $('.spinSize .btn:first-of-type').on('click', function() {
            $('.spinSize input').val( parseInt($('.spinSize input').val(), 10) + 1 );
        });
        $('.spinSize .btn:last-of-type').on('click', function() {
            $('.spinSize input').val( parseInt($('.spinSize input').val(), 10) - 1 );
        });
        
        this.delegateEvents();
        return this;
    }

}

export default StyleLineView;
